<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import EmployeeAPI from "@/services/employee/employeeAPI";
import Table from "@/components/standard/PromotionActivities/PromotionTable";
import CompanyAPI from "@/services/company/companyAPI";
import ActivityAPI from "@/services/standards/trainingProgram/activityHealthAPI";
import ItemAPI from "@/services/items/itemsAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import newScoresAPI from "../../../../services/newScores/newScoresAPI";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "3.1.2 Actividades de medicina del trabajo y de Promoción y Prevención en Salud",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
    CheckModal,
  },
  data() {
    return {
      title: "3.1.2 Actividades de medicina del trabajo y de Promoción y Prevención en Salud",

      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Actividades de medicina del trabajo y de Promoción y Prevención en Salud",
          active: true,
        },
      ],
      list: [],

      programa: [
        {
          name: "Biomecánico",
          id: 1,
        },
        {
          name: "Auditivo",
          id: 2,
        },
        {
          name: "Respiratorio",
          id: 3,
        },
        {
          name: "Biológico",
          id: 4,
        },
        {
          name: "Psicosocial",
          id: 5,
        },
        {
          name: "Otro",
          id: 6,
        },
      ],

      theme: null,

      program: {
        activity: null,
        scheduled_date: null,
        observations: null,
        programs_id: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      trainingList: [],
      usersList: [],

      item: null,
      itemStatus: "No cumplido",

      itemData: null,
      submitted: false,
      loading: true,

      company: this.$store.getters["company/getCompany"] || null,

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  validations: {
    program: {
      programs_id: {
        required,
      },
      employee_id: {
        required,
      },
    },
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(24)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getTrainingPrograms() {
      ActivityAPI.getTraining(this.companyID)
        .then((response) => {
          this.loading = false;
          this.trainingList = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getDataTraining() {
      if (!this.theme) return;
      this.program.theme = this.theme.id;
      this.program.date = this.theme.start_date;
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              let informacion = res.employee;
              this.usersList = informacion;
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },

    save() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        const data = {
          activity: this.program.activity,
          scheduled_date: this.program.scheduled_date,
          observations: this.program.observations,
          programs_id: this.program.programs_id,
          employee_id: this.program.employee_id,
          companies_id: this.program.companies_id,
        };
        ActivityAPI.save(data)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 24,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.sendNotification(26, 24, true);
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Se ha registrado con éxito!",
                    text: "¡Se ha registrado con éxito!",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    getItems() {
      try {
        CompanyItemsAPI.getStatus(this.companyID, 24)
          .then((response) => {
            this.item = response || null;
            this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
          })
          .catch((error) => {
            this.item = null;
            this.itemStatus = null;
            console.log(error);
          });
      } catch (error) {
        this.item = null;
        this.itemStatus = null;
        console.log(error);
      }
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 24,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },
  },

  mounted() {
    this.getItems();
    this.getItemData();
    this.getUsers();
    this.getTrainingPrograms();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <CheckModal>
                    <p class="text-justify">
                      Es un requisito que la empresa desarrolle actividades de
                      medicina del trabajo, prevención y promoción de la salud y
                      programas de vigilancia epidemiológica orientados a la
                      gestión de las enfermedades laborales de conformidad con
                      las prioridades identificadas en el diagnóstico de
                      condiciones de salud y con los peligros/riesgos
                      prioritarios.
                    </p>
                    <p class="text-justify">
                      Se debe hacer una programación de las
                      actividades correspondientes a cada programa de vigilancia
                      (Biomecánico, Respiratorio, Auditivo, Psicosocial, entre
                      otros), y almacenar las evidencias que constaten la
                      ejecución de dichas actividades.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>
              <div class="form-row col-md-12 d-flex justify-content-end">
                <a :href="`/forms/actividades-medicina`" underline class="mx-1">
                  Programa de promoción y prevención en salud
                </a>
              </div>

              <hr />
              <form class="form-group" @submit.prevent="save">
                <div class="form-row col-12">
                  <b-form-group class="col-md-4 px-2" label="Programa" label-for="theme">
                    <b-form-select :disabled="!allowAccess() || !getRole('Crear')" required id="theme"
                      v-model="program.programs_id" v-on:change="getDataTraining()" :class="{
                        'is-invalid':
                          $v.program.programs_id.$error && submitted,
                      }">
                      <b-form-select-option v-for="(item, index) in programa" :key="index" :value="item.id">
                        {{ item.name }}
                      </b-form-select-option>
                    </b-form-select>
                    <div v-if="submitted && $v.program.programs_id.$error">
                      <small v-if="!$v.program.programs_id.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-4 px-2" label="Fecha Programada" label-for="trainingDate">
                    <b-form-input type="date" id="trainingDate" :disabled="!allowAccess() || !getRole('Crear')"
                      v-model="program.scheduled_date">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group class="col-md-4" label="Responsable" label-for="employee">
                    <select id="employeeID" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="program.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                    <div v-if="submitted && $v.program.employee_id.$error">
                      <small v-if="!$v.program.employee_id.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>
                <div class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Actividad" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="program.activity">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="program.observations">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1">
                    Cancelar
                  </button>
                </div>
              </form>
              <hr />

              <Table :companyID="Number(companyID)" />
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
